/* @flow */
import { Observable } from 'rxjs';
import { ActionsObservable } from 'redux-observable';
import createDebugger from 'debug';

const debug = createDebugger('app:modules:sectors:epics'); // eslint-disable-line no-unused-vars

import {
  FETCH,
  FETCH_SUCCESS,
  FETCH_FAILURE,
} from './action-types.js';

export const endpoint = '/services/sectors';

const fetchEpic = (action$: ActionsObservable<*>, store: any, { ajax }: any) =>
  action$.ofType(FETCH)
    .switchMap(() =>
      ajax.get(endpoint)
        .map(({ response }) => ({
          type: FETCH_SUCCESS,
          payload: response,
        }))
        .catch(err => Observable.of({
          type: FETCH_FAILURE,
          error: true,
          payload: err,
          meta: {
            alert: { type: 'error', text: 'Sectors could not be fetched.' },
          },
        })));

export default fetchEpic;



// WEBPACK FOOTER //
// ./src/app/modules/sectors/epics.js